import { render, staticRenderFns } from "./ThreatsMitigationHistory.vue?vue&type=template&id=faaebf98"
import script from "./ThreatsMitigationHistory.vue?vue&type=script&lang=js"
export * from "./ThreatsMitigationHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports